var historyModule = angular.module('historyModule', ['classy', 'addHistory', 'historyDataModel']);
